import { createSelector } from '@ngrx/store';
import { createFilterStateSelector } from '../create-filter-state-selector/create-filter-state.selector';

/**
 * @param filterInstanceId
 * @param nestedGroupId
 * @returns fields that relate to specified nestedGroupId
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createNestedGroupIdFieldsSelector = (filterInstanceId: string, nestedGroupId: string) =>
  createSelector(createFilterStateSelector(filterInstanceId), (filterState) => {
    if (!filterState?.fieldsState) {
      return [];
    }

    return Object.values(filterState.fieldsState).filter((field) => field.nestedGroupId === nestedGroupId);
  });
